import { render, staticRenderFns } from "./batch-search-dialog.vue?vue&type=template&id=156c220b&scoped=true&"
import script from "./batch-search-dialog.vue?vue&type=script&lang=js&"
export * from "./batch-search-dialog.vue?vue&type=script&lang=js&"
import style0 from "./batch-search-dialog.vue?vue&type=style&index=0&id=156c220b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c220b",
  null
  
)

export default component.exports